export default {
      id: "Icon--date-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--date",
      toString: function () {
        return this.url;
      }
    }